import { apiFetch } from "@/lib/api";

export interface ManufacturingSalesOrderLineRow {
  id: number;
  sku: string;
  quantity: number;
  remark: string | null;
}

export interface ManufacturingSalesOrderDetailRow {
  id: number;
  number: string;
  status: string | null;
  mv_id: number | null;
  client_fs_account_name: string | null;
  end_user_fs_account_name: string | null;
  submitted: string | null;
  sgs_ship_by_date: string | null;
  ship_to_recipient: string | null;
  ship_to_city: string | null;
  ship_to_state: string | null;
  payment_terms: string | null;
  customer_purchase_order_number: string | null;
  special_instructions: string | null;
  items: ManufacturingSalesOrderLineRow[];
}

export async function fetchManufacturingSalesOrderDetails(
  search: string,
): Promise<ManufacturingSalesOrderDetailRow[]> {
  const response = await apiFetch<{ ok: true; rows: ManufacturingSalesOrderDetailRow[] }>(
    "/api/manufacturing/sales-order-details",
    { query: search.trim() !== "" ? { q: search.trim() } : undefined },
  );
  return response.rows;
}

export interface ManufacturingSalesOrderRelated {
  lines: Array<{
    salesOrderItemId: number;
    batchId: number;
    quantityShipped: number;
    quantityAssembled: number;
  }>;
  shipments: Array<{ id: number; batchId: number }>;
  invoices: Array<{ shipmentId: number; invoiceMvId: number }>;
  approvalTicketId: string | null;
  documents: Array<{ id: string; kindLabel: string; fileName: string }>;
  activity: Array<{ id: string; timestamp: string; actorDisplayName: string | null; action: string; detail: string }>;
  priorOrders: Array<{ salesOrderId: number; salesOrderNumber: string; sku: string; quantity: number }>;
}

export async function fetchManufacturingSalesOrderDetail(
  salesOrderId: number,
): Promise<{ row: ManufacturingSalesOrderDetailRow; related: ManufacturingSalesOrderRelated }> {
  return apiFetch<{ ok: true; row: ManufacturingSalesOrderDetailRow; related: ManufacturingSalesOrderRelated }>(
    `/api/manufacturing/sales-order-details/${salesOrderId}`,
  );
}
